import { Injectable } from '@angular/core';
import { AppConfig } from './app-config.model';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private config: AppConfig | null = null;

  async load(): Promise<void> {
    if (this.config) {
      return;
    }

    const fromWindow = window.__APP_CONFIG__;
    if (fromWindow?.backendUrl) {
      this.config = this.normalizeConfig(fromWindow);
      return;
    }

    const response = await fetch('/app-config.json', { cache: 'no-store' });
    if (!response.ok) {
      throw new Error(`Failed to load app config: ${response.status}`);
    }

    const json = (await response.json()) as Partial<AppConfig>;
    this.config = this.normalizeConfig(json);
  }

  get backendUrl(): string {
    if (!this.config) {
      throw new Error('App config has not been loaded yet.');
    }

    return this.config.backendUrl;
  }

  private normalizeConfig(config: Partial<AppConfig>): AppConfig {
    if (!config.backendUrl) {
      throw new Error('Missing required app config value: backendUrl');
    }

    return {
      backendUrl: config.backendUrl.replace(/\/$/, '')
    };
  }
}
